import { onClientHydrated } from './renderingState';

let ssrApiData: Partial<Record<string, unknown>> | undefined;
const listeners: (() => void)[] = [];

let fired = false;

// Actions

export function setSsrApiData(data: Record<string, unknown>) {
  ssrApiData = data;

  listeners.forEach((listener) => listener());
  fired = true;
}

// Getters

export function onSsrApiDataSet(fn: () => void) {
  if (ssrApiData) {
    fn();
    return;
  }

  if (!fired) listeners.push(fn);
}

/**
 * @deprecated This will be removed soon
 */
export function currentSsrApiData() {
  return ssrApiData!;
}

// Event listeners

onClientHydrated(() => {
  // Erase data to avoid caching between page changes
  ssrApiData = undefined;
});
